module.exports = __webpack_public_path__ + "img/calendar-28.5428d788.svg";